<template>
  <div>
    <van-tabbar fixed v-model="active"  @change="onChange" :class="flga ? 'Beyond' : ''">
      <van-tabbar-item name="Home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item name="SimList" icon="hotel-o">SIM卡</van-tabbar-item>
      <van-tabbar-item name="User" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      active: 'Home',
      flga: false
    }
  },
  watch: {
    $route: function (e) {
      if (e.name === 'EquipmentBeyond') {
        this.active = 'sssss'
        this.flga = true
      }
      // else {
      //   if (e.name === 'Equipment' && e.params.id !== 'tz') {
      //     this.active = 'sssss'
      //     this.flga = true
      //   } else {
      //     this.flga = false
      //     this.active = e.name
      //   }
      // }
    }
  },
  computed: {},
  methods: {
    // 底部导航栏点击事件
    onChange (e) {
      if (e !== 'Equipment') {
        this.$router.push({ name: e })
      } else {
        this.$router.push('/Equipment/tz')
      }
    },
    changs (e) { this.active = e }
  },
  beforeCreate () {},
  created () {
    const that = this
    window.addEventListener('popstate', function (e) {
      if (e.state) {
        const name = location.href.split('#')[1].split('/')[1]
        that.changs(name)
      }
    }, false)
    this.$store.commit('setSignOut', 'no')
    const name = location.href.split('#')[1].split('/')[1]
    this.active = name
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-tabbar {
    height: 100px!important;
    border-top: 2px solid #d0d0d0!important;
    z-index: 999;
  }
  .Beyond {
    /deep/.van-tabbar-item {
      color: #646566;
    }
    /deep/.van-tabbar-item:nth-child(2) {
      color: #1989fa;
    }
  }
</style>
